import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressSearchLookupComponent } from './address-search-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [AddressSearchLookupComponent],
  exports: [AddressSearchLookupComponent]
})
export class AddressSearchLookupModule { }
